<template>
  <svg :width="width"
       :height="height"
       viewBox="0 0 100 100"
       role="presentation"
       @click="$emit('click')">
    <path :fill="disabled ? disabledStateColor : iconColor" d="M88.898 28.199H30.5c-3.3 0-5.898-2.7-5.898-5.898v-.2c0-3.3 2.699-5.898 5.898-5.898h58.398c3.3 0 5.898 2.7 5.898 5.898v.2c.004 3.199-2.597 5.898-5.898 5.898zM17.199 22.199c0 3.316-2.684 6-6 6a6 6 0 0 1-6-6c0-3.313 2.688-6 6-6a6 6 0 0 1 6 6M88.898 55.801H30.5c-3.3 0-5.898-2.7-5.898-5.898v-.2c0-3.3 2.699-5.898 5.898-5.898h58.398c3.3 0 5.898 2.7 5.898 5.898v.2C94.8 53.102 92.2 55.8 88.898 55.8zM17.199 49.801a6 6 0 0 1-6 6c-3.312 0-6-2.688-6-6a6 6 0 0 1 6-6c3.316 0 6 2.684 6 6M88.898 83.301H30.5c-3.3 0-5.898-2.7-5.898-5.898v-.2c0-3.3 2.699-5.898 5.898-5.898h58.398c3.3 0 5.898 2.7 5.898 5.898v.2C94.8 80.7 92.2 83.3 88.898 83.3zM17.199 77.301a6 6 0 0 1-6 6c-3.312 0-6-2.688-6-6a6 6 0 0 1 6-6c3.316 0 6 2.684 6 6"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
